/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type DisplayPromoCode_item$ref = any;
type DisplayPromoCode_promotion$ref = any;
export type ItemDisplayPromoCodeWrapper_item$ref = any;
export type ItemDisplayPromoCodeWrapper_item = {
    readonly activePromotion: {
        readonly " $fragmentRefs": DisplayPromoCode_promotion$ref;
    } | null;
    readonly " $fragmentRefs": DisplayPromoCode_item$ref;
    readonly " $refType": ItemDisplayPromoCodeWrapper_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ItemDisplayPromoCodeWrapper_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String"
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "activePromotion",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId"
                }
            ],
            "concreteType": "Promotion",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "DisplayPromoCode_promotion",
                    "args": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "DisplayPromoCode_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '21a3db7cf25f22bfcfb50a01d715bdff';
export default node;
